import {
    deleteFilesClientLoading,
    deleteFilesClientRequest,
    deleteFilesClientSuccess,
    deleteFilesClientReject,
    deleteFilesClientReset
} from "../../actions/filesClient/delete";

export const deleteFilesClient = (formData) => async (dispatch, getState) => {
    dispatch(deleteFilesClientLoading());
    try {
        const { data } = await deleteFilesClientRequest(formData, getState);
        dispatch(deleteFilesClientSuccess(data))
    } catch (error) {
        dispatch(deleteFilesClientReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteFilesClientReset()) }, 3000);
    }
    return Promise.resolve();
};
